export const APIROUTE = "https://waterinsights.kedra.info:8000/"

